import { memo } from 'react';

import { getIconSize, type SizeType } from './iconProps';
import { Announcement } from './regular/Announcement';
import { Bell } from './regular/Bell';
import { Calendar } from './regular/Calendar';
import { Changelogs } from './regular/Changelogs';
import { Cloud } from './regular/Cloud';
import { Gbs } from './regular/Gbs';
import { Help } from './regular/Help';
import { IconNext } from './regular/IconNext';
import { Idea } from './regular/Idea';
import { Inbox } from './regular/Inbox';
import { LaptopMinimal } from './regular/LaptopMinimal';
import { Lightning } from './regular/Lightning';
import { Location } from './regular/Location';
import { Logout } from './regular/Logout';
import { Operations } from './regular/Operations';
import { Overview } from './regular/Overview';
import { Pin } from './regular/Pin';
import { Plus } from './regular/Plus';
import { Projects } from './regular/Projects';
import { Reports } from './regular/Reports';
import { Roadmap } from './regular/Roadmap';
import { Search } from './regular/Search';
import { Tick } from './regular/Tick';
import { Timesheet } from './regular/Timesheet';
import { Versionone } from './regular/Versionone';
import { Wiki } from './regular/Wiki';
import { Xmark } from './regular/Xmark';
import { Bulb } from './regular/Bulb';
import { Analysing } from './regular/Analzing';
import { UserRefresh } from './regular/UserRefresh';
import { Briefcase } from './regular/Briefcase';
import { IdCard } from './regular/IdCard';
import { Dot } from './regular/Dot';
import { FileUser } from './regular/FileUser';
import { House } from './regular/House';
import { Phone } from './regular/Phone';
import { CalendarClock } from './regular/CalendarClock';
import { ArrowRight } from './regular/ArrowRight';
import { ArrowLeft, ChevronArrowLeft } from './regular/ArrowLeft';
import { Calculator } from './regular/Calculator';
import { ClockPlus } from './regular/ClockPlus';
import { Send } from './regular/Send';
import { X } from './regular/X';
import { Trash } from './regular/Trash';
import { Pen } from './regular/Pen';
import { Warning } from './regular/Warning';
import { CircleCross } from './regular/CircleCross';
import { CircleDashed } from './regular/CircleDashed';
import { Loader } from './regular/Loader';
import { CircleCheck } from './regular/CircleCheck';
import { Exclamation } from './regular/Exclamation';
import { WallClock } from './regular/WallClock';
import { Flag } from './regular/Flag';
import { TriangleAlert } from './regular/TriangleAlert';
import { CircleTrendingUp } from './regular/CircleTrendingUp';
import { Copy } from './regular/Copy';
import { EditIcon } from './regular/EditIcon';
import { CrossFilled } from './regular/CrossFilled';
import { Settings } from './regular/Settings';
import { Spinner } from '@/components/ui/icons/regular/Spinner.tsx';

const icons = {
  'regular-timesheet': Timesheet,
  'regular-search': Search,
  'regular-tick': Tick,
  'regular-pin': Pin,
  'regular-bell': Bell,
  'regular-overview': Overview,
  'regular-inbox': Inbox,
  'regular-operations': Operations,
  'regular-gbs': Gbs,
  'regular-projects': Projects,
  'regular-announcement': Announcement,
  'regular-reports': Reports,
  'regular-wiki': Wiki,
  'regular-roadmap': Roadmap,
  'regular-changelogs': Changelogs,
  'regular-versionone': Versionone,
  'regular-help': Help,
  'regular-location': Location,
  'regular-cloud': Cloud,
  'regular-next': IconNext,
  'regular-logout': Logout,
  'regular-laptop-minimal': LaptopMinimal,
  'regular-calendar': Calendar,
  'regular-idea': Idea,
  'regular-lightning': Lightning,
  'regular-xmark': Xmark,
  'regular-plus': Plus,
  'regular-bulb': Bulb,
  'regular-analyse': Analysing,
  'regular-user-refresh': UserRefresh,
  'regular-briefcase': Briefcase,
  'regular-idcard': IdCard,
  'regular-dot': Dot,
  'regular-file-user': FileUser,
  'regular-house': House,
  'regular-phone': Phone,
  'regular-calendar-clock': CalendarClock,
  'regular-arrow-right': ArrowRight,
  'regular-arrow-left': ArrowLeft,
  'regular-calculator': Calculator,
  'regular-clock-plus': ClockPlus,
  'regular-send': Send,
  'regular-x': X,
  'regular-trash': Trash,
  'regular-pen': Pen,
  'regular-warning': Warning,
  'regular-circle-cross': CircleCross,
  'chevron-icon-left': ChevronArrowLeft,
  'regular-circle-dashed': CircleDashed,
  'regular-loader': Loader,
  'regular-circle-check': CircleCheck,
  'reg-exclamation': Exclamation,
  'reg-wall-clock': WallClock,
  'regular-flag': Flag,
  'regular-triangle-alert': TriangleAlert,
  'regular-circle-trending-up': CircleTrendingUp,
  'regular-copy': Copy,
  'regular-edit': EditIcon,
  'regular-cross-filled': CrossFilled,
  'regular-settings': Settings,
  'regular-spinner': Spinner,
};

export type IconType = keyof typeof icons;

export interface IconProps {
  fill?: string;
  size?: SizeType;
  icon: IconType;
  className?: string;
}

const IconsComponent = memo(({ icon, fill, size }: Readonly<IconProps>) => {
  const sizes = size ? getIconSize(size) : 18;
  const Component = icons[icon];

  return (
    <Component
      fill={fill ?? '#A6A09B'}
      size={sizes}
    />
  );
});

IconsComponent.displayName = 'IconsComponent';
export default IconsComponent;
